<template>
  <div>
    <Modal
      v-model="modalShow"
      :title="$t('Employee_not_submitted')"
      width="88%"
      :footer-hide="true"

      ><!-- 未提交员工 -->
      <div>
        <Form inline label-position="left" :label-width="120">
          <Row :gutter="24">
            <Col :xs="12" :sm="12" :md="6" :lg="4">
              <FormItem :label="$t('Employee_Code')"
                ><!-- 员工号 -->
                <Input v-model="searchItem.empCode"></Input>
              </FormItem>
            </Col>
            <Col :xs="12" :sm="12" :md="6" :lg="4">
              <FormItem :label="$t('userName')"
                ><!-- 员工姓名 -->
                <Input v-model="searchItem.userName"></Input>
              </FormItem>
            </Col>
            <Col :xs="12" :sm="12" :md="6" :lg="4">
              <FormItem :label="$t('BU')"><!-- 业务单元 -->
                  <Select v-model="searchItem.businessUnit" clearable style="width: 200px;">
                      <Option v-for="item in businessUnitList" :value="item.code" :key="item.code">{{lang=="zh"?item.ch_value:item.en_value}}</Option>
                  </Select>
              </FormItem>
          </Col>
           <Col :xs="12" :sm="12" :md="6" :lg="4">
              <FormItem :label="$t('Department')"><!-- 大区 -->
                  <Select v-model="searchItem.department" clearable  style="width:  200px;">
                      <Option v-for="item in departmentList" :value="item.code" :key="item.code">{{lang=="zh"?item.ch_value:item.en_value}}</Option>
                  </Select>
              </FormItem>
          </Col>
          <Col :xs="12" :sm="12" :md="6" :lg="4">
            <FormItem :label="$t('Line_Manager')"
              ><!-- 直线上级 -->
              <Input v-model="searchItem.dirSupUserName"></Input>
            </FormItem>
          </Col>
            <Col :xs="12" :sm="12" :md="6" :lg="1">
              <Button type="primary" @click="total=0,pageInfo.pageNo=1,getData()"
                ><!-- 检索 -->{{ $t("Search") }}</Button
              >
            </Col>
          </Row>
        </Form>
      </div>
      <Table border :loading="loading" :columns="columns" :data="data"></Table>
      <Table border ref="table" :loading="loading" :columns="columns2" :data="data2" v-show="false"></Table>
      <div style="margin-top:10px;display:flex;justify-content: flex-end;">
        <Page :total="total" @on-change="pageChange" />
      </div>
      <div style="margin-top:10px;display:flex;justify-content: flex-end;">
        <Button  @click="exportData()">导出</Button>
      </div>
    </Modal>
  </div>
</template>

<script>
import axios from "axios";
export default {
  props: { businessUnitList:[], departmentList:[]},
  data() {
    return {
      modalShow: false,
      loading: false,
      searchItem: {
        year: "",
        levelNum: ""
      },
      data: [],
      pageInfo: {
        itemCount: 0,
        pageNo: 1,
        pageSize: 10
      },
      total: 0,
      data2:[],
    };
  },
  computed: {
    columns() {
      return [
        {
          title: this.$t("BU") /* 业务单元 */,
          key: this.lang == "zh" ? "businessUnit" : "enBusinessUnit",
          align: "center",
          minWidth: 120
        },
        {
          title: this.$t("Department") /* 部门 */,
          key: this.lang == "zh" ? "department" : "enDepartment",
          align: "center",
          minWidth: 120
        },
        {
          title: this.$t("Employee_Code") /* 员工号 */,
          key: "empCode",
          align: "center",
          minWidth: 120
        },
        {
          title: this.$t("Chinese_Name") /* 中文姓名 */,
          key: "userCName",
          align: "center",
          minWidth: 120
        },
        {
          title: this.$t("English_Name") /* 英文姓名 */,
          key: "userEName",
          align: "center",
          minWidth: 120
        },
        {
          title: this.$t("Position_Name_Chinese") /* 职位 */,
          key: "position",
          align: "center",
          minWidth: 120
        },
        {
          title: this.$t("Position_Name_English") /* 英文职位 */,
          key: "enPosition",
          align: "center",
          minWidth: 120
        },
        {
          title: this.$t("Line_Manager") /* 直线经理 */,
          key: this.lang == "zh" ? "dirSupName" : "dirSupEName",
          align: "center",
          minWidth: 120
        }
      ];
    },
    columns2() {
      return [
        {
          title: this.$t("BU") /* 业务单元 */,
          key: this.lang == "zh" ? "businessUnit" : "enBusinessUnit",
          align: "center",
          minWidth: 120
        },
        {
          title: this.$t("Department") /* 部门 */,
          key: this.lang == "zh" ? "department" : "enDepartment",
          align: "center",
          minWidth: 120
        },
        {
          title: this.$t("Employee_Code") /* 员工号 */,
          key: "empCode",
          align: "center",
          minWidth: 120
        },
        {
          title: this.$t("Chinese_Name") /* 中文姓名 */,
          key: "userCName",
          align: "center",
          minWidth: 120
        },
        {
          title: this.$t("English_Name") /* 英文姓名 */,
          key: "userEName",
          align: "center",
          minWidth: 120
        },
        {
          title: this.$t("Position_Name_Chinese") /* 职位 */,
          key: "position",
          align: "center",
          minWidth: 120
        },
        {
          title: this.$t("Position_Name_English") /* 英文职位 */,
          key: "enPosition",
          align: "center",
          minWidth: 120
        },
        {
          title: this.$t("Line_Manager") /* 直线经理 */,
          key: this.lang == "zh" ? "dirSupName" : "dirSupEName",
          align: "center",
          minWidth: 120
        }
      ];
    },
    lang() {
      return this.$store.getters.selectLangeData;
    }
  },
  methods: {
    getData() {
      this.loading = true;
      axios
        .post("/achReport/selectIsNotSubmit", {
          ...this.pageInfo,
          ...this.searchItem
        })
        .then(res => {
          this.loading = false;
          if (res) {
            this.data = res.data;
            this.total = parseInt(res.pageInfo.total);
          }
        });
    },
    exportData(){
      this.loading = true;
      axios
        .post("/achReport/selectIsNotSubmit", {
          pageNo:1,
          pageSize:999999,
          ...this.searchItem
        })
        .then(res => {
          this.loading = false;
          if (res) {
            this.data2 = res.data;
            this.total = parseInt(res.pageInfo.total);
            this.$nextTick(()=> {
              this.$exportExcel('table',`${this.$t('未提交员工名单')}`+this.$nowDate.dateVal(new Date(),'YYYY-MM-DD HH-mm'))/* '员工一览' */
            })
          }
        });
    },
    pageChange(val) {
      this.pageInfo.pageNo = val;
      this.getData();
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/process/performanceManagement/components/modalComponents/NoSubmitEmp.vue